<template>
  <b-modal
    id="modal-download-file"
    style="width: min-content; padding: 10px"
    hide-footer
    centered
    @hidden="resetModal"
    :noCloseOnBackdrop="isBusy"
    :noCloseOnEsc="isBusy"
    :hideHeaderClose="isBusy"
    title="Subir Documentos"
  >
      <div class="mt-5">
        <div class="row mb-5">
          <div class="col-12">
            <UploadFile
              title="Arrastra aquí el archivo de anexos y pruebas"
              :id="'file-document-litigio-1'"
              @uploadFile="uploadFile"
            />
          </div>
        </div>
        <div class="row align-content-center justify-content-center">
          <div>
            <button
              :disabled="isBusy"
              class="button_primary mr-4"
              @click.prevent="saveDocument()"
            >
              <span>Subir archivos</span>
              <b-spinner v-if="isBusy" />
            </button>
          </div>
          <button
            class="button-secundary"
            :disabled="isBusy || files.length > 0"
            @click.prevent="$bvModal.hide('modal-download-file')"
          >
            <span>Cancelar</span>
          </button>
        </div>
      </div>
  </b-modal>
</template>

<script>
import processSevices from "@/services/legal/service.js";
import useInputs from "@/components/general/Inputs";
const { Input } = useInputs();
import UploadFile from "../UploadFile.vue";

export default {
  components: {
    Input,
    UploadFile,
  },
  props: {
    processId: {
      type: Number,
      default: null,
    },
    documentType: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isBusy: false,
      files: [],
    };
  },
  methods: {
    async saveDocument() {
      const me = this;
      me.isBusy = true;
      const formData = new FormData();
      formData.append('type', me.documentType);
      formData.append('process_id', me.processId);
      me.files.forEach((file, index) => {
        formData.append(`files[${index}]`, file);
      });
      try {
        const res = await processSevices.saveProcessFiles(formData);
        console.log(res)
        me.$bvModal.hide("modal-download-file");
        me.$emit("onSuccess", "Documentos cargados con éxito");
      } catch (error) {
        me.$emit("onError", "Error al cargar los documentos");
      } finally {
        me.isBusy = false;
      }
    },
    resetModal() {
      const me = this;
      me.formData = {
        name: "",
      };
    },
    uploadFile(files) {
      const me = this;
      me.files = files;
    },
  },
};
</script>
<style lang="scss">
.button_primary {
  display: flex;
  align-items: center;
  background-color: #5d5fef;
  height: 40px;
  border-radius: 8px;
  font-size: 18px;
  gap: 10px;
  border: none;
  color: white;
  padding: 15px;
}
.modal-title {
  font-size: 22px !important;
}
</style>
